import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=ca9883a2&scoped=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=ca9883a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9883a2",
  null
  
)

export default component.exports